export type DatabaseCellAttachmentSourceIdParts = {
  databaseId: string;
  rowId: string;
  propertyId: string;
  refId: string;
  blobId: string;
};

const DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX = 'database-cell-v2';
const LEGACY_DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX = 'database-cell';

function encodePart(value: string): string {
  return encodeURIComponent(value);
}

function decodePart(value: string): string | null {
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
}

export function createDatabaseCellAttachmentSourceId(
  parts: DatabaseCellAttachmentSourceIdParts
): string {
  return [
    DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX,
    encodePart(parts.databaseId),
    encodePart(parts.rowId),
    encodePart(parts.propertyId),
    encodePart(parts.refId),
    encodePart(parts.blobId),
  ].join(':');
}

export function parseDatabaseCellAttachmentSourceId(
  id: string
): DatabaseCellAttachmentSourceIdParts | null {
  const parts = id.split(':');
  if (parts[0] === DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX) {
    if (parts.length !== 6) return null;
    const [, databaseId, rowId, propertyId, refId, blobId] =
      parts.map(decodePart);
    if (!databaseId || !rowId || !propertyId || !refId || !blobId) {
      return null;
    }
    return { databaseId, rowId, propertyId, refId, blobId };
  }

  if (
    parts[0] === LEGACY_DATABASE_CELL_ATTACHMENT_SOURCE_PREFIX &&
    parts.length >= 5
  ) {
    const [, databaseId, rowId, propertyId, ...fileParts] = parts;
    const blobId = fileParts.at(-1);
    const refId =
      fileParts.length > 1 ? fileParts.slice(0, -1).join(':') : blobId;
    if (!databaseId || !rowId || !propertyId || !refId || !blobId) {
      return null;
    }
    return {
      databaseId,
      rowId,
      propertyId,
      refId,
      blobId,
    };
  }

  return null;
}
